module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/close-151.vue");


//////////////////
// WEBPACK FOOTER
// ./en/css/close.md
// module id = 568
// module chunks = 457